import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class Tab extends BasicEntity {
cloneTab: boolean | null;
code: string;
color: string;
description: TranslatedEmb;
icon: string;
label: TranslatedEmb;
owner: string;
physTempCode: string;
shared: boolean | null;
viewOrder: number | null;
visionCode: string;
}

